import { FC, useState } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { GenericPopup, ButtonTheme } from '@apply/components';

type ExpiredTokenModalV2Props = {
    timeout: number;
    promptBeforeIdle: number;
    onLogout: () => void;
};

export const ExpiredTokenModalV2: FC<ExpiredTokenModalV2Props> = ({ timeout, promptBeforeIdle, onLogout }) => {
    const [showExpiredTokenModal, setShowExpiredTokenModal] = useState(false);

    const { activate } = useIdleTimer({
        onIdle: onLogout,
        onActive: () => setShowExpiredTokenModal(false),
        onPrompt: () => setShowExpiredTokenModal(true),
        timeout,
        promptBeforeIdle,
        throttle: 500,
    });

    const _handleCancel = () => {
        activate();
        setShowExpiredTokenModal(false);
    };

    const actionButtons = [
        {
            id: 'continueButton',
            theme: ButtonTheme.Primary,
            disabled: false,
            children: 'Continue Working',
            width: '150px',
            handleClick: _handleCancel,
        },
        {
            id: 'logoutButton',
            theme: ButtonTheme.Decline,
            children: 'Log Out',
            width: '150px',
            handleClick: onLogout,
        },
    ];

    return (
        <GenericPopup
            id='sessionExpirationPopup'
            isOpen={showExpiredTokenModal}
            actionButtons={actionButtons}
            handleClose={_handleCancel}
            aria-labelledby='alert-dialog-title'
            hideOnOutsideClick={true}
            showCloseButton={true}
            showTitle={true}
            title='Session Expiration'
            width='450px'
            height='280px'
            maxWidth='90%'
            maxHeight='60%'
            buttonAlignment='right'
            wrapTitle={true}
        >
            <div>
                <h5>Session about to expire!</h5>
                <div style={{ paddingTop: '20px' }}>
                    Your session is about to expire. You will be logged out in 5 minutes. To continue your session, select
                    Continue Working.
                </div>
            </div>
        </GenericPopup>
    );
};
